var _path, _path2, _path3, _path4, _path5, _rect, _g, _g2, _rect2, _g3, _g4, _rect3, _g5, _g6, _rect4, _g7, _g8, _path6, _path7, _path8, _path9, _path10, _path11, _g9, _g10, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsFit12(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 711.9 550.6",
    enableBackground: "new 0 0 711.9 550.6",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DBE125",
    d: "M485.3,225l-1.7,5.4l-6.4,20.8l-4.6-1.4l9.2-29.7l0.1-0.4l3.4,1c-0.1,0.6-0.2,1.3-0.2,2 C485.1,223.6,485.2,224.3,485.3,225z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M632.6,225l-1.7,5.4l-6.4,20.8l-4.6-1.4l9.2-29.7l0.1-0.4l3.4,1c-0.1,0.6-0.2,1.3-0.2,2 C632.4,223.6,632.4,224.3,632.6,225z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#DBE125",
    d: "M511.7,222.6c-1.4-7-7.5-12.2-14.9-12.2c-7.5,0-13.7,5.4-15,12.6c-0.2,0.9-0.2,1.7-0.2,2.6 c0,2.8,0.7,5.4,2.1,7.6c2.6,4.5,7.5,7.6,13.2,7.6c5.6,0,10.6-3.1,13.2-7.7c1.3-2.2,2-4.8,2-7.6C512,224.6,511.9,223.6,511.7,222.6z  M496.8,237.3c-5.7,0-10.4-4.1-11.5-9.5c-0.1-0.7-0.2-1.5-0.2-2.2c0-0.7,0.1-1.3,0.2-2c0.9-5.5,5.7-9.7,11.5-9.7 c5.8,0,10.6,4.2,11.5,9.7c0.1,0.6,0.2,1.3,0.2,1.9c0,0.7-0.1,1.4-0.2,2v0C507.3,233.1,502.6,237.3,496.8,237.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M511.7,219.8c-1.4-7-7.5-12.2-14.9-12.2c-7.5,0-13.7,5.4-15,12.6c-0.2,0.9-0.2,1.7-0.2,2.6 c0,2.8,0.7,5.4,2.1,7.6c2.6,4.5,7.5,7.6,13.2,7.6c5.6,0,10.6-3.1,13.2-7.7c1.3-2.2,2-4.8,2-7.6C512,221.8,511.9,220.8,511.7,219.8z  M496.8,234.5c-5.7,0-10.4-4.1-11.5-9.5c-0.1-0.7-0.2-1.5-0.2-2.2c0-0.7,0.1-1.3,0.2-2c0.9-5.5,5.7-9.7,11.5-9.7 c5.8,0,10.6,4.2,11.5,9.7c0.1,0.6,0.2,1.3,0.2,1.9c0,0.7-0.1,1.4-0.2,2v0C507.3,230.4,502.6,234.5,496.8,234.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M521,249.8l-4.6,1.4l-6.4-20.9l-1.7-5.5v0c0.1-0.7,0.2-1.3,0.2-2c0-0.7-0.1-1.3-0.2-1.9l3.4-1l0,0L521,249.8 z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38.4,
    y: 97.8,
    fill: "#FFFFFF",
    width: 82,
    height: 16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M10.6,97.8v16H2.4c-1.3,0-2.4-1.1-2.4-2.4v-11.3c0-1.3,1.1-2.4,2.4-2.4H10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBE125",
    d: "M37.9,63.7v84.1c0,1.5-1.1,2.7-2.3,2.7h-7c-1.3,0-2.3-1.2-2.3-2.7V63.7c0-1.5,1.1-2.7,2.3-2.7h7 C36.8,61,37.9,62.2,37.9,63.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M39.8,63.7v84.1c0,1.5-1,2.7-2.3,2.7h-6.8c-1.3,0-2.3-1.2-2.3-2.7V63.7c0-1.5,1-2.7,2.3-2.7h6.8 C38.7,61,39.8,62.2,39.8,63.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBE125",
    d: "M26.2,72.3v66.9h-6.6c-1.3,0-2.3-1-2.3-2.3V74.7c0-1.3,1.1-2.3,2.3-2.3H26.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M26.2,72.3v66.9h-5.1c-1,0-1.8-1-1.8-2.3V74.7c0-1.3,0.8-2.3,1.8-2.3H26.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBE125",
    d: "M17.3,84.4v42.6h-4.9c-1,0-1.9-0.8-1.9-1.9V86.3c0-1,0.8-1.9,1.9-1.9H17.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M17.3,84.4v42.6h-3.9c-0.8,0-1.5-0.8-1.5-1.9V86.3c0-1,0.7-1.9,1.5-1.9H17.3z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M147,97.8v16h8.2c1.3,0,2.4-1.1,2.4-2.4v-11.3c0-1.3-1.1-2.4-2.4-2.4H147z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBE125",
    d: "M119.4,63.7v84.1c0,1.5,1.1,2.7,2.4,2.7h7.1c1.3,0,2.4-1.2,2.4-2.7V63.7c0-1.5-1.1-2.7-2.4-2.7h-7.1 C120.5,61,119.4,62.2,119.4,63.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M117.8,63.7v84.1c0,1.5,1,2.7,2.3,2.7h6.8c1.3,0,2.3-1.2,2.3-2.7V63.7c0-1.5-1-2.7-2.3-2.7h-6.8 C118.8,61,117.8,62.2,117.8,63.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBE125",
    d: "M131.3,72.3v66.9h6.6c1.3,0,2.3-1,2.3-2.3V74.7c0-1.3-1.1-2.3-2.3-2.3H131.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M131.3,72.3v66.9h5.1c1,0,1.8-1,1.8-2.3V74.7c0-1.3-0.8-2.3-1.8-2.3H131.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBE125",
    d: "M140.2,84.4v42.6h4.9c1,0,1.9-0.8,1.9-1.9V86.3c0-1-0.8-1.9-1.9-1.9H140.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M140.2,84.4v42.6h3.9c0.8,0,1.5-0.8,1.5-1.9V86.3c0-1-0.7-1.9-1.5-1.9H140.2z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 259.4,
    y: 99.1,
    fill: "#DBE125",
    width: 82,
    height: 16
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DBE125",
    d: "M231.6,99.1v16h-8.2c-1.3,0-2.4-1.1-2.4-2.4v-11.3c0-1.3,1.1-2.4,2.4-2.4H231.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M258.9,65.1v84.1c0,1.5-1.1,2.7-2.3,2.7h-7c-1.3,0-2.3-1.2-2.3-2.7V65.1c0-1.5,1.1-2.7,2.3-2.7h7 C257.9,62.3,258.9,63.6,258.9,65.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBE125",
    d: "M260.8,65.1v84.1c0,1.5-1,2.7-2.3,2.7h-6.8c-1.3,0-2.3-1.2-2.3-2.7V65.1c0-1.5,1-2.7,2.3-2.7h6.8 C259.8,62.3,260.8,63.6,260.8,65.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M247.3,73.7v66.9h-6.6c-1.3,0-2.3-1-2.3-2.3V76c0-1.3,1.1-2.3,2.3-2.3H247.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBE125",
    d: "M247.3,73.7v66.9h-5.1c-1,0-1.8-1-1.8-2.3V76c0-1.3,0.8-2.3,1.8-2.3H247.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M238.4,85.8v42.6h-4.9c-1,0-1.9-0.8-1.9-1.9V87.7c0-1,0.8-1.9,1.9-1.9H238.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBE125",
    d: "M238.4,85.8v42.6h-3.6c-0.8,0-1.4-0.8-1.4-1.9V87.7c0-1,0.6-1.9,1.4-1.9H238.4z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DBE125",
    d: "M368,99.1v16h8.2c1.3,0,2.4-1.1,2.4-2.4v-11.3c0-1.3-1.1-2.4-2.4-2.4H368z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M340.5,65.1v84.1c0,1.5,1.1,2.7,2.4,2.7h7.1c1.3,0,2.4-1.2,2.4-2.7V65.1c0-1.5-1.1-2.7-2.4-2.7h-7.1 C341.5,62.3,340.5,63.6,340.5,65.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBE125",
    d: "M338.8,65.1v84.1c0,1.5,1,2.7,2.3,2.7h6.8c1.3,0,2.3-1.2,2.3-2.7V65.1c0-1.5-1-2.7-2.3-2.7h-6.8 C339.9,62.3,338.8,63.6,338.8,65.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M352.4,73.7v66.9h6.6c1.3,0,2.3-1,2.3-2.3V76c0-1.3-1.1-2.3-2.3-2.3H352.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBE125",
    d: "M352.4,73.7v66.9h5.1c1,0,1.8-1,1.8-2.3V76c0-1.3-0.8-2.3-1.8-2.3H352.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M361.3,85.8v42.6h4.9c1,0,1.9-0.8,1.9-1.9V87.7c0-1-0.8-1.9-1.9-1.9H361.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBE125",
    d: "M361.3,85.8v42.6h3.6c0.8,0,1.4-0.8,1.4-1.9V87.7c0-1-0.6-1.9-1.4-1.9H361.3z"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 51.9,
    y: 438.7,
    fill: "#DBE125",
    width: 245.4,
    height: 16
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DBE125",
    d: "M328.1,436.2v20.9h10.7c1.7,0,3.1-1.4,3.1-3.1v-14.7c0-1.7-1.4-3.1-3.1-3.1H328.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M292.1,391.7v109.9c0,2,1.4,3.6,3.1,3.6h9.3c1.7,0,3.1-1.6,3.1-3.6V391.7c0-1.9-1.4-3.6-3.1-3.6h-9.3 C293.5,388.2,292.1,389.8,292.1,391.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBE125",
    d: "M289.9,391.7v109.9c0,2,1.3,3.6,3,3.6h8.9c1.6,0,3-1.6,3-3.6V391.7c0-1.9-1.4-3.6-3-3.6h-8.9 C291.3,388.2,289.9,389.8,289.9,391.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M307.6,403v87.4h8.6c1.7,0,3.1-1.4,3.1-3.1v-81.2c0-1.7-1.4-3.1-3.1-3.1H307.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBE125",
    d: "M307.6,403v87.4h6.7c1.3,0,2.4-1.4,2.4-3.1v-81.2c0-1.7-1.1-3.1-2.4-3.1H307.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M319.2,418.8v55.7h6.4c1.3,0,2.5-1.1,2.5-2.4v-50.8c0-1.4-1.1-2.5-2.5-2.5H319.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBE125",
    d: "M319.2,418.8v55.7h4.7c1,0,1.8-1.1,1.8-2.4v-50.8c0-1.4-0.8-2.5-1.8-2.5H319.2z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DBE125",
    d: "M15.8,436.2v20.9H5.1c-1.7,0-3.1-1.4-3.1-3.1v-14.7c0-1.7,1.4-3.1,3.1-3.1H15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M51.8,391.7v109.9c0,2-1.4,3.6-3.1,3.6h-9.3c-1.7,0-3.1-1.6-3.1-3.6V391.7c0-1.9,1.4-3.6,3.1-3.6h9.3 C50.4,388.2,51.8,389.8,51.8,391.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBE125",
    d: "M53.9,391.7v109.9c0,2-1.3,3.6-3,3.6H42c-1.6,0-3-1.6-3-3.6V391.7c0-1.9,1.4-3.6,3-3.6h8.9 C52.6,388.2,53.9,389.8,53.9,391.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M36.2,403v87.4h-8.6c-1.7,0-3.1-1.4-3.1-3.1v-81.2c0-1.7,1.4-3.1,3.1-3.1H36.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBE125",
    d: "M36.2,403v87.4h-6.7c-1.3,0-2.4-1.4-2.4-3.1v-81.2c0-1.7,1.1-3.1,2.4-3.1H36.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M24.6,418.8v55.7h-6.4c-1.3,0-2.5-1.1-2.5-2.4v-50.8c0-1.4,1.1-2.5,2.5-2.5H24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBE125",
    d: "M24.6,418.8v55.7h-4.7c-1,0-1.8-1.1-1.8-2.4v-50.8c0-1.4,0.8-2.5,1.8-2.5H24.6z"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 415.9,
    y: 438.7,
    fill: "#FFFFFF",
    width: 245.4,
    height: 16
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M692,436.2v20.9h10.7c1.7,0,3.1-1.4,3.1-3.1v-14.7c0-1.7-1.4-3.1-3.1-3.1H692z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBE125",
    d: "M656,391.7v109.9c0,2,1.4,3.6,3.1,3.6h9.3c1.7,0,3.1-1.6,3.1-3.6V391.7c0-1.9-1.4-3.6-3.1-3.6h-9.3 C657.4,388.2,656,389.8,656,391.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M653.9,391.7v109.9c0,2,1.3,3.6,3,3.6h8.9c1.6,0,3-1.6,3-3.6V391.7c0-1.9-1.4-3.6-3-3.6h-8.9 C655.2,388.2,653.9,389.8,653.9,391.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBE125",
    d: "M671.5,403v87.4h8.6c1.7,0,3.1-1.4,3.1-3.1v-81.2c0-1.7-1.4-3.1-3.1-3.1H671.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M671.5,403v87.4h6.7c1.3,0,2.4-1.4,2.4-3.1v-81.2c0-1.7-1.1-3.1-2.4-3.1H671.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBE125",
    d: "M683.2,418.8v55.7h6.4c1.3,0,2.5-1.1,2.5-2.4v-50.8c0-1.4-1.1-2.5-2.5-2.5H683.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M683.2,418.8v55.7h4.7c1,0,1.8-1.1,1.8-2.4v-50.8c0-1.4-0.8-2.5-1.8-2.5H683.2z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M379.7,436.2v20.9H369c-1.7,0-3.1-1.4-3.1-3.1v-14.7c0-1.7,1.4-3.1,3.1-3.1H379.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBE125",
    d: "M415.7,391.7v109.9c0,2-1.4,3.6-3.1,3.6h-9.3c-1.7,0-3.1-1.6-3.1-3.6V391.7c0-1.9,1.4-3.6,3.1-3.6h9.3 C414.3,388.2,415.7,389.8,415.7,391.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M417.8,391.7v109.9c0,2-1.3,3.6-3,3.6H406c-1.6,0-3-1.6-3-3.6V391.7c0-1.9,1.4-3.6,3-3.6h8.9 C416.5,388.2,417.8,389.8,417.8,391.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBE125",
    d: "M400.2,403v87.4h-8.6c-1.7,0-3.1-1.4-3.1-3.1v-81.2c0-1.7,1.4-3.1,3.1-3.1H400.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M400.2,403v87.4h-6.7c-1.3,0-2.4-1.4-2.4-3.1v-81.2c0-1.7,1.1-3.1,2.4-3.1H400.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBE125",
    d: "M388.5,418.8v55.7h-6.4c-1.3,0-2.5-1.1-2.5-2.4v-50.8c0-1.4,1.1-2.5,2.5-2.5H388.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M388.5,418.8v55.7h-4.7c-1,0-1.8-1.1-1.8-2.4v-50.8c0-1.4,0.8-2.5,1.8-2.5H388.5z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#DBE125",
    d: "M536.4,326.3L524,291.6l-7.7-21.5l-5.9-16.6c-1.1-3,0.5-6.4,3.5-7.5l7.5-2.7c3-1.1,6.4,0.5,7.5,3.5l5.9,16.5 c0,0,0,0,0,0.1l20.1,56.1c1.1,3-0.5,6.4-3.5,7.4l-7.5,2.7C540.8,330.9,537.4,329.3,536.4,326.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M519.5,263.5l8.7-3.1c2.7-1,5.7,0.5,6.6,3.1l20.3,56.7c1,2.7-0.5,5.7-3.1,6.6l-8.7,3.1 c-2.7,1-5.7-0.5-6.6-3.1l-20.3-56.7C515.4,267.5,516.8,264.5,519.5,263.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#DBE125",
    d: "M119.8,248.9c0,0,0,67.5,0,72c0,4.5-0.9,10.8-2.5,12c-1.7,1.2-8.1,3-21.5,3s-19.8-1.8-21.5-3 c-1.7-1.2-2.5-7.5-2.5-12c0-4.5,0-72,0-72s0.3-2.3,3-6.7c2.7-4.4,4.2-8.7-1.4-11.8c0,0-1.5-0.6-1.5-2.4c0-1.9-0.5-5,2-6.6 c0,0,10.8-2.1,21.8-2.1c11,0,21.8,2.1,21.8,2.1c2.5,1.6,2,4.7,2,6.6c0,1.9-1.5,2.4-1.5,2.4c-5.5,3.1-4.1,7.3-1.4,11.8 C119.5,246.6,119.8,248.9,119.8,248.9z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M119.3,220.2c0,1-1.6,1.2-1.6,1.2s-10.8-2.1-21.8-2.1c-11,0-21.8,2.1-21.8,2.1s-1.6-0.2-1.6-1.2 c0-1,1.1-11.8,1.1-11.8s2.1-4,14.8-5.5c0,0,1.2-0.1,1-7.1h-2.1c0,0,0.1-2.1,8.6-2.1s8.7,2.1,8.7,2.1h-2.3c-0.2,7,1,7.1,1,7.1 c12.7,1.4,14.8,5.5,14.8,5.5S119.2,219.2,119.3,220.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M51.9,248.9c0,0,0,67.5,0,72c0,4.5-0.9,10.8-2.5,12c-1.7,1.2-8.1,3-21.5,3s-19.8-1.8-21.5-3 c-1.7-1.2-2.5-7.5-2.5-12c0-4.5,0-72,0-72s0.3-2.3,3-6.7c2.7-4.4,4.2-8.7-1.4-11.8c0,0-1.5-0.6-1.5-2.4c0-1.9-0.5-5,2-6.6 c0,0,10.8-2.1,21.8-2.1c11,0,21.8,2.1,21.8,2.1c2.5,1.6,2,4.7,2,6.6c0,1.9-1.5,2.4-1.5,2.4c-5.5,3.1-4.1,7.3-1.4,11.8 C51.6,246.6,51.9,248.9,51.9,248.9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#DBE125",
    d: "M51.3,220.2c0,1-1.6,1.2-1.6,1.2s-10.8-2.1-21.8-2.1c-11,0-21.8,2.1-21.8,2.1s-1.6-0.2-1.6-1.2 c0-1,1.1-11.8,1.1-11.8s2.1-4,14.8-5.5c0,0,1.2-0.1,1-7.1h-2.1c0,0,0.1-2.1,8.6-2.1s8.7,2.1,8.7,2.1h-2.3c-0.2,7,1,7.1,1,7.1 c12.7,1.4,14.8,5.5,14.8,5.5S51.3,219.2,51.3,220.2z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DBE125",
    d: "M277,296.6c0,9.3-3,18-8.2,24.9c0,0-12.5,5.2-33.8,5.2c-21.3,0-33.8-5.2-33.8-5.2c-5.2-7-8.2-15.6-8.2-24.9 c0-9.6,3.2-18.5,8.7-25.5c1.6-2.1,3.3-4,5.3-5.7c7.4-6.7,17.3-10.8,28.1-10.8c10.8,0,20.7,4.1,28.1,10.8c1.9,1.7,3.7,3.6,5.3,5.7 C273.8,278.1,277,287,277,296.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M271.5,275.8c-1.6-2.1-6.5-8.7-8.4-10.5c0,0,38.4-40.5-28.1-40.5c-66.5,0-28.1,40.5-28.1,40.5 c-1.9,1.7-6.5,6.6-8,8.7c0,0-48.2-60.1,36.2-60.1S271.5,275.8,271.5,275.8z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M390.9,296.6c0,9.3-3,18-8.2,24.9c0,0-12.5,5.2-33.8,5.2c-21.3,0-33.8-5.2-33.8-5.2 c-5.2-7-8.2-15.6-8.2-24.9c0-9.6,3.2-18.5,8.7-25.5c1.6-2.1,3.3-4,5.3-5.7c7.4-6.7,17.3-10.8,28.1-10.8c10.8,0,20.7,4.1,28.1,10.8 c1.9,1.7,3.7,3.6,5.3,5.7C387.7,278.1,390.9,287,390.9,296.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBE125",
    d: "M385.5,275.8c-1.6-2.1-6.5-8.7-8.4-10.5c0,0,38.4-40.5-28.1-40.5c-66.5,0-28.1,40.5-28.1,40.5 c-1.9,1.7-6.5,6.6-8,8.7c0,0-48.2-60.1,36.2-60.1S385.5,275.8,385.5,275.8z"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#DBE125",
    d: "M458.3,326.2l12.4-34.7l7.7-21.5l5.9-16.6c1.1-3-0.5-6.4-3.5-7.5l-7.5-2.7c-3-1.1-6.4,0.5-7.5,3.5l-5.9,16.5 c0,0,0,0,0,0.1l-20.1,56.1c-1.1,3,0.5,6.4,3.5,7.4l7.5,2.7C453.9,330.8,457.3,329.2,458.3,326.2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M475.2,263.4l-8.7-3.1c-2.7-1-5.7,0.5-6.6,3.1l-20.3,56.7c-1,2.7,0.5,5.7,3.1,6.6l8.7,3.1 c2.7,1,5.7-0.5,6.6-3.1l20.3-56.7C479.3,267.4,477.9,264.4,475.2,263.4z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M659,222.6c-1.4-7-7.5-12.2-14.9-12.2c-7.5,0-13.7,5.4-15,12.6c-0.2,0.9-0.2,1.7-0.2,2.6 c0,2.8,0.7,5.4,2.1,7.6c2.6,4.5,7.5,7.6,13.2,7.6c5.6,0,10.6-3.1,13.2-7.7c1.3-2.2,2-4.8,2-7.6C659.3,224.6,659.1,223.6,659,222.6z  M644,237.3c-5.7,0-10.4-4.1-11.5-9.5c-0.1-0.7-0.2-1.5-0.2-2.2c0-0.7,0.1-1.3,0.2-2c0.9-5.5,5.7-9.7,11.5-9.7 c5.8,0,10.6,4.2,11.5,9.7c0.1,0.6,0.2,1.3,0.2,1.9c0,0.7-0.1,1.4-0.2,2v0C654.6,233.1,649.8,237.3,644,237.3z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#DBE125",
    d: "M659,219.8c-1.4-7-7.5-12.2-14.9-12.2c-7.5,0-13.7,5.4-15,12.6c-0.2,0.9-0.2,1.7-0.2,2.6 c0,2.8,0.7,5.4,2.1,7.6c2.6,4.5,7.5,7.6,13.2,7.6c5.6,0,10.6-3.1,13.2-7.7c1.3-2.2,2-4.8,2-7.6C659.3,221.8,659.1,220.8,659,219.8z  M644,234.5c-5.7,0-10.4-4.1-11.5-9.5c-0.1-0.7-0.2-1.5-0.2-2.2c0-0.7,0.1-1.3,0.2-2c0.9-5.5,5.7-9.7,11.5-9.7 c5.8,0,10.6,4.2,11.5,9.7c0.1,0.6,0.2,1.3,0.2,1.9c0,0.7-0.1,1.4-0.2,2v0C654.6,230.4,649.8,234.5,644,234.5z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#DBE125",
    d: "M668.2,249.8l-4.6,1.4l-6.4-20.9l-1.7-5.5v0c0.1-0.7,0.2-1.3,0.2-2c0-0.7-0.1-1.3-0.2-1.9l3.4-1l0,0 L668.2,249.8z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M683.6,326.3l-12.4-34.7l-7.7-21.5l-5.9-16.6c-1.1-3,0.5-6.4,3.5-7.5l7.5-2.7c3-1.1,6.4,0.5,7.5,3.5 l5.9,16.5c0,0,0,0,0,0.1l20.1,56.1c1.1,3-0.5,6.4-3.5,7.4l-7.5,2.7C688,330.9,684.7,329.3,683.6,326.3z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#DBE125",
    d: "M666.7,263.5l8.7-3.1c2.7-1,5.7,0.5,6.6,3.1l20.3,56.7c1,2.7-0.5,5.7-3.1,6.6l-8.7,3.1 c-2.7,1-5.7-0.5-6.6-3.1l-20.3-56.7C662.6,267.5,664,264.5,666.7,263.5z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M605.6,326.2l12.4-34.7l7.7-21.5l5.9-16.6c1.1-3-0.5-6.4-3.5-7.5l-7.5-2.7c-3-1.1-6.4,0.5-7.5,3.5l-5.9,16.5 c0,0,0,0,0,0.1l-20.1,56.1c-1.1,3,0.5,6.4,3.5,7.4l7.5,2.7C601.1,330.8,604.5,329.2,605.6,326.2z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#DBE125",
    d: "M622.5,263.4l-8.7-3.1c-2.7-1-5.7,0.5-6.6,3.1l-20.3,56.7c-1,2.7,0.5,5.7,3.1,6.6l8.7,3.1 c2.7,1,5.7-0.5,6.6-3.1l20.3-56.7C626.6,267.4,625.2,264.4,622.5,263.4z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#DBE125",
    d: "M500.2,135.5c0,0-37.7-26.5-44.5-43.2c6.1-14.9,18.4-26.6,33.7-32C489.4,60.3,485.6,104.7,500.2,135.5z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M564.7,113.8c0,2.9-0.2,5.7-0.6,8.5c-0.7,4.4-1.8,8.7-3.5,12.7c-4,9.8-10.6,18.3-19.1,24.5 c-1,0.7-1.9,1.4-2.9,2c-8.8,5.6-19.3,8.9-30.5,8.9c-31.3,0-56.6-25.3-56.6-56.6c0-7.6,1.5-14.8,4.2-21.5 c6.8,16.7,44.5,43.2,44.5,43.2c-14.5-30.8-10.8-75.2-10.8-75.2c5.8-2,12.1-3.2,18.7-3.2C539.3,57.2,564.7,82.5,564.7,113.8z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#DBE125",
    d: "M564,122.2c-0.7,4.4-1.8,8.7-3.5,12.7c-4,9.8-10.6,18.3-19.1,24.5c-13.6-18.9-17.3-77.1-17.3-77.1 C534.5,98,549.9,111.7,564,122.2z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M647.4,135.5c0,0-37.7-26.5-44.5-43.2c6.1-14.9,18.4-26.6,33.7-32C636.6,60.3,632.9,104.7,647.4,135.5z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#DBE125",
    d: "M711.9,113.8c0,2.9-0.2,5.7-0.6,8.5c-0.7,4.4-1.8,8.7-3.5,12.7c-4,9.8-10.6,18.3-19.1,24.5 c-1,0.7-1.9,1.4-2.9,2c-8.8,5.6-19.3,8.9-30.5,8.9c-31.3,0-56.6-25.3-56.6-56.6c0-7.6,1.5-14.8,4.2-21.5 c6.8,16.7,44.5,43.2,44.5,43.2c-14.5-30.8-10.8-75.2-10.8-75.2c5.8-2,12.1-3.2,18.7-3.2C686.5,57.2,711.9,82.5,711.9,113.8z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M711.3,122.2c-0.7,4.4-1.8,8.7-3.5,12.7c-4,9.8-10.6,18.3-19.1,24.5c-13.6-18.9-17.3-77.1-17.3-77.1 C681.8,98,697.1,111.7,711.3,122.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsFit12);
export default __webpack_public_path__ + "static/media/iconsFit-12.9e2b9bfe017a9654cec79b86a7b8061a.svg";
export { ForwardRef as ReactComponent };